import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
  groupRoles,
  profilePicValidityCheck,
} from "../../../utils/constants";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
} from "reactstrap";
import "./MemberItem.css";
import Select from "react-select";
import { isMobile } from "../../../utils/deviceInfo";

class MemberItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      members: [],
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isRemoved: false,
      item: this.props.single_member,
      role: this.props.single_member.role,
      currentUserRole:
        this.props.currentUserRole >= 0 ? this.props.currentUserRole : 1000,
      group: this.props.group,
    };
  }

  componentDidMount() {
    // let{id}=this.props.match.params
    // let that=this
    // let payload = {
    //   groupId:id,
    //   modelName:'Users',
    //   noLoader:true
    // }
    // this.props.highlightMenu('M')
    // axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
    //   that.setState({
    //     members: data.data
    //   })
    // })
  }

  removeMember = () => {
    let { item } = this.state;
    let payload = {
      organizationId: this.props.group.organizationId,
      groupId: this.props.group._id,
      userId: item._id,
      noLoader: true,
    };

    let that = this;

    this.setState({ isRemoved: true });
    axios.post(url.removeGroupMembers, payload).then(({ data }) => {
      that.setState({
        removedItem: this.state.item,
        // isRemoved:true,
        isSuccess: true,
      });
      that.props.removeMember(this.state.item.o_id);
    });
  };

  viewMember = (user) => {
    if (isMobile) {
      this.props.handleProfilePopup(user);
    } else {
      let link = `/home/${this.props.user.profile.organizationId._id}/profile/${user.o_id}`;
      this.props.history.push(link);
    }
  };

  componentWillReceiveProps(nextProps){
  
   
    if(JSON.stringify(this.state.currentUserRole) !== JSON.stringify(nextProps.currentUserRole)){
      this.setState({currentUserRole:nextProps.currentUserRole})
      
    }
    if(JSON.stringify(this.state.item) !== JSON.stringify(nextProps.single_member)){
      this.setState({item:nextProps.single_member,role:nextProps.single_member.role})
    }
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  handleRoleChange = (role) => {
    let payload = {
      role,
      groupId: this.props.group._id,
      userId: this.state.item._id,
      organizationId: this.props.group.organizationId,
      noLoader: true,
    };
    this.setState({ role: role.value });
    let that = this;
    axios.post(url.changeGroupRole, payload).then(({ data }) => {
      // that.setState({
      // })
      if(payload.userId == that.props.user.profile._id){
        this.props.updateCurrentRole(role.value,that.props.user.profile._id)
      }else{
        this.props.updateCurrentRole(role.value,payload.userId)
      }
    });
  };

  groupMemberAuthority = (currentUserRole, group, currentUser, item) => {
    if (currentUserRole == 0 || group.groupOwner._id == currentUser._id) {
      if(currentUser._id == item._id){
        return false
      }else{
        return true;
      }
    } else if (currentUserRole == 1) {
      if (group.groupOwner._id == item._id || item.role == 0) {
        return false;
      } else {
        return true;
      }
    } else if (currentUserRole == 2) {
      if (group.groupOwner._id == item._id || item.role == 0) {
        return false;
      } else {
        if (item.role == 1 || item.role == 0) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };

  renderMembers = (tasks) => {
    const { orgAdmin } = this.props.user.profile;
    let {
      members,
      currentUserRole,
      removedItem,
      isRemoved,
      item,
      group,
      role,
    } = this.state;

    console.log(item);
    const isAnonymousMember = item.isAnonymous;

    if (isRemoved != true) {
      if (!isMobile) {
        return (
          <span className="grp_member_item_row_container" key={this.props.key}>
            {item && item.justAdded ? (
              <div className="grp_single_new_member_alert">Just added</div>
            ) : null}

            <li className={`table-row ${isRemoved ? "" : ""}`}>
              {isAnonymousMember ? (
                <div className="col col-6" data-label="Name">
                  <div className="grp_member_profile_image cursor-pointer">
                    <span
                      className="list-item__avatar"
                      data-letters={"AU"}
                    ></span>
                  </div>

                  <div className="grp_member_profile_details">
                    <div className="linkedToolView">Anonymous User</div>
                    {item &&
                    item.groupItm &&
                    item.groupItm.date_joined &&
                    item.groupItm.date_joined != "undefined" ? (
                      <div className="grp_member_profile_joined">
                        joined{" "}
                        {moment(item.groupItm.date_joined).format(
                          "MMM Do, YYYY"
                        )}{" "}
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : (
                <div className="col col-6" data-label="Name">
                  <div
                    className="grp_member_profile_image cursor-pointer"
                    onClick={() => (isMobile ? this.viewMember(item) : null)}
                  >
                    {profilePicValidityCheck(item.profilePic) ? (
                      <div className="list-item__avatar">
                        <img src={item.profilePic} />
                      </div>
                    ) : (
                      <span
                        className="list-item__avatar"
                        data-letters={this.getInitials(item)}
                      ></span>
                    )}
                  </div>

                  <div className="grp_member_profile_details">
                    <div
                      className="linkedToolView"
                      onClick={() => this.viewMember(item)}
                    >
                      {" "}
                      {item.firstName} , {item.lastName}
                    </div>

                    <div className="grp_member_profile_joined">
                      joined {moment(item.dateJoined).format("MMM Do, YYYY")}{" "}
                    </div>
                  </div>
                </div>
              )}

              <div className="col col-5" data-label="Role">
                {/* {((currentUserRole >=0 &&
                  (currentUserRole == 2 || currentUserRole == 1 || currentUserRole == 0)) ||
                  group.createdBy._id == this.props.user.profile._id) && */}
                {this.groupMemberAuthority(
                  currentUserRole,
                  group,
                  this.props.user.profile,
                  item
                ) && 
                !this.props.hideRoleSelector ? (
                  <div className={"mobile-select-width"}>
                    <Select
                      name="role-select"
                      value={groupRoles.filter((e) => e.value == role)[0]}
                      onChange={(r) => this.handleRoleChange(r)}
                      options={groupRoles.filter((e) => e.isHidden != true)}
                      // valueKey='key'
                      // labelKey='value'
                      clearable={false}
                      disabled={false}
                    />
                  </div>
                ) : (
                  <span>
                    {item.role >= 0
                      ? groupRoles.filter((e) => e.value == item.role)[0].label
                      : group.groupOwner._id == item.o_id
                      ? groupRoles.filter((e) => e.value == 0)[0].label
                      : groupRoles.filter((e) => e.role == "Member")[0].label}
                  </span>
                )}
              </div>
              {this.groupMemberAuthority(
                  currentUserRole,
                  group,
                  this.props.user.profile,
                  item
                ) ? (
                <div className="col col-1 remove-group-member" data-label="">
                  <span
                    onClick={() => this.removeMember()}
                    className="chart-item-menu flaticon-trash"
                  />
                  {/* Remove  */}
                </div>
              ) : (
                <div
                  className="col col-1 remove-group-member"
                  data-label=""
                ></div>
              )}
            </li>
          </span>
        );
      } else {
        return (
          <div
            className="card linkedChartItemStyling group_list_items_container group_list_items_001"
            key={this.props.key}
          >
            {item && item.justAdded ? (
              <div className="grp_single_new_member_alert">Just added</div>
            ) : null}

            <div className="text-right mr-2">
              {this.groupMemberAuthority(
                  currentUserRole,
                  group,
                  this.props.user.profile,
                  item
                ) ? (
                <div className="remove-group-member" data-label="">
                  <span
                    onClick={() => this.removeMember()}
                    className="chart-item-menu flaticon-trash"
                  />
                  {/* Remove  */}
                </div>
              ) : (
                <div className="remove-group-member" data-label=""></div>
              )}
            </div>

            {isAnonymousMember ? (
              <div
                onClick={() => (isMobile ? this.viewMember(item) : null)}
                className="cursor-pointer d-flex justify-content-center"
              >
                <span
                  className="list-item__avatar large-card-mobile mt-3"
                  data-letters={"AU"}
                ></span>
              </div>
            ) : (
              <div
                onClick={() => (isMobile ? this.viewMember(item) : null)}
                className="cursor-pointer d-flex justify-content-center"
              >
                {profilePicValidityCheck(item.profilePic) ? (
                  <img src={item.profilePic} />
                ) : (
                  <span
                    className="list-item__avatar large-card-mobile mt-3"
                    data-letters={this.getInitials(item)}
                  ></span>
                )}
              </div>
            )}

            <div
              className="card-body text-center cursor-pointer"
              onClick={() => (isMobile ? this.viewMember(item) : null)}
            >
              <span>
                {isAnonymousMember ? (
                  <span className="grp_list_page_item_title card-member-lg-title">
                    {" "}
                    Anonymous User
                  </span>
                ) : (
                  <span className="grp_list_page_item_title card-member-lg-title">
                    {" "}
                    {item.firstName} {item.lastName}
                  </span>
                )}
                <span className="grp_list_page_item_details"></span> &nbsp;
                <span className="grp_list_page_item_details">
                  joined {moment(item.dateJoined).format("MMM Do, YYYY")}{" "}
                </span>
              </span>
            </div>

            <div className="card-footer text-center">
              <div className="">
                {this.groupMemberAuthority(
                  currentUserRole,
                  group,
                  this.props.user.profile,
                  item
                ) ? (
                  <div className={"mobile-select-width"}>
                    <Select
                      name="role-select"
                      value={groupRoles.filter((e) => e.value == role)[0]}
                      onChange={(r) => this.handleRoleChange(r)}
                      options={groupRoles.filter((e) => e.isHidden != true)}
                      // valueKey='key'
                      // labelKey='value'
                      clearable={false}
                      disabled={false}
                    />
                  </div>
                ) : (
                  <span>
                    {item.role
                      ? groupRoles.filter((e) => e.value == item.role)[0].label
                      : group.groupOwner._id == item.o_id
                      ? groupRoles.filter((e) => e.value == 0)[0].label
                      : groupRoles.filter((e) => e.role == "Member")[0].label}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      }
    } else {
      return <span className="hide" />;
    }
  };

  render() {
    return this.renderMembers();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MemberItem, axios)));
